import { Suspense } from 'react';
import { useRouteLoaderData, Await, useActionData, useNavigation, redirect } from 'react-router-dom';
import { UpdateUser } from '../repo/UsersRepo.js'
import { GetCurrentUserDataSession } from '../repo/SessionsRepo.js';
import FormUpdateUser from '../components/FormUpdateUser.jsx'
import UserUpdated from '../components/UserUpdated.jsx'

function UserUpdatePage() {
  const responseData = useActionData()
  const signInNavigation = useNavigation()
  const isSubmitting = signInNavigation.state === 'submitting'
  const userData = useRouteLoaderData("user-update");

  return (
    <section>
      <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto lg:py-0">
        <p className="flex items-center lg:mt-24 mb-6 text-2xl font-semibold text-gray-900">
          Alterar Nome
        </p>

        {(responseData && responseData.status === 200) ? <UserUpdated/> : (
        <Suspense fallback={<p>Loading...</p>}>
          <Await resolve={userData}>
            {(loadedUserData) => <FormUpdateUser isSubmitting={isSubmitting} userName={loadedUserData.data.name} responseData={responseData} />}
          </Await>
        </Suspense>
        )}
      </div>
    </section>
  )
}

export default UserUpdatePage

export async function action({request}) {
  const data = await request.formData()

  const userData = {
    user: {
      name: data.get('name').substring(0, 50),
    }
  }

  const response = await UpdateUser(userData)

  if (response.status === 200) {
    document.getElementById("currentUserName").textContent = data.get('name').substring(0, 50)
  }

  return response
}

export async function loader() {
  return (await GetCurrentUserDataSession()).data;
}
